<div class="bbb_deals_featured">
  <button (click)="regresarPagina()" style="width: 100px; height: 40px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>
  <div class="container">
    <div class="row">
      <div class="col d-flex flex-lg-row flex-column align-items-center justify-content-center" *ngIf="existeInmueble" >
        <!-- bbb_deals -->
        <div class="bbb_deals">

          <div class="bbb_deals_slider_container">
            <!-- bbb_deals Item -->
            <div class=" bbb_deals_item">
              <div style="font-size: 20px;" align="center" class="bbb_deals_item_category"><b>{{inmueble.tipo}}</b></div>
              <div class="p-carousel">
                <div class="carousel slide" data-ride="carousel" id="{{inmueble._id}}">
                  <div class="carousel-inner" role="listbox">
                    <div *ngFor="let avatar of inmueble.imagen; let i = index" class="carousel-item"
                      [ngClass]="{'active': i===0}">
                      <img style="width:310px; height:310px" [src]='avatar.url' class="img-responsive image">
                    </div>
                  </div>

                  <div>
                    <a class="carousel-control-prev" href="#{{inmueble._id}}" role="button" data-slide="prev"><span
                        class="carousel-control-prev-icon"></span>
                      <span class="sr-only">Previous</span></a><a class="carousel-control-next" href="#{{inmueble._id}}"
                      role="button" data-slide="next"><span class="carousel-control-next-icon"></span><span
                        class="sr-only">Next</span></a>
                  </div>
                </div>
              </div>
              <br>
              <div class="bbb_deals_info_line d-flex flex-row justify-content-start">
                <div class="bbb_deals_item_price_a ml-auto"
                  [ngStyle]="{'background-color':inmueble.estado == 'DISPONIBLE' ? '#007bff':'#fc4b6c'}">
                  <b>{{inmueble.estado}}</b></div>
              </div>
              <hr>
              <div class="bbb_deals_content">
                <div class="bbb_deals_info_line d-flex flex-row justify-content-start">
                  <div class="bbb_deals_item_name">{{inmueble.nombre}}</div>
                  <div class="bbb_deals_item_price ml-auto">${{inmueble.precioalquiler}}</div>
                </div>
                <div class="available">
                  <div class="bbb_deals_item_category">Código del inmueble:</div>
                  <div class="available_title">{{inmueble.codigo}}</div>
                  <br>
                  <div class="bbb_deals_item_category">Dirección:</div>
                  <div class="available_title">{{inmueble.direccion}}</div>
                  <br>
                  <div class="bbb_deals_item_category">Servicios incluidos:</div>
                  <div class="available_title">{{inmueble.servicio}}</div>
                  <br>
                  <div class="bbb_deals_item_category">Descripción:</div>
                  <div class="available_title">{{inmueble.descripcion}}</div>
                  <div class="available_bar"><span style="width:17%"></span></div>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- Featured -->
      </div>
    </div>
  </div>
</div>
